export const rulesEvaluationTypes = {
  wound: "Wound",
  risk: "Risk"
};
